import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import useParams from 'components/data/URLParams/useParams'
import {getAnonymousId} from 'modules/meta/selectors'

import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {
  trackLoginClick,
  trackSignUpClick
} from '@vio/core/src/auth/modules/actions'
import {
  selectAuthEnabled,
  selectIsAuthenticated,
  selectIsLoading
} from '@vio/core/src/auth/modules/selectors'
import {
  AuthenticationFlows,
  SourceComponentType
} from '@vio/core/src/auth/types/Auth'
import {useLogIn} from '@vio/shared/src/authentication/hooks/useLogIn'
import {MobileMenuUserSection} from '@vio/shared/src/user/account/MobileMenuUserSection'

const UserSideMenuWithStore = () => {
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(selectIsAuthenticated)
  const authEnabled = useSelector(selectAuthEnabled)
  const logIn = useLogIn()
  const isLoading = useSelector(selectIsLoading)
  const anonymousId = useSelector(getAnonymousId)
  const {brand} = useBrand()
  const urlParams = useParams()
  const SEARCH_URL = brand.siteAddresses.address

  const {utm_source} = urlParams
  const isKayakTraffic = utm_source === 'kayak'

  const handleOnSignUpClick = () => {
    const component = SourceComponentType.PreferencesOverlay
    dispatch(trackSignUpClick(component))

    if (anonymousId) {
      logIn({
        flow: AuthenticationFlows.SignUp,
        sourceComponent: component,
        anonymousId
      })
    }
  }

  const handleOnLoginClick = () => {
    const component = SourceComponentType.PreferencesOverlay
    dispatch(trackLoginClick(component))

    if (anonymousId) {
      logIn({
        flow: AuthenticationFlows.Login,
        sourceComponent: component,
        anonymousId
      })
    }
  }

  const onClickEditAccount = () => {
    window.location.href = `${SEARCH_URL}/user/account`
  }

  return authEnabled ? (
    <MobileMenuUserSection
      isAuthenticated={Boolean(isAuthenticated)}
      isLoading={Boolean(isLoading)}
      onSignUpClick={handleOnSignUpClick}
      onLogInClick={handleOnLoginClick}
      onClickEditAccount={onClickEditAccount}
      isSignInHidden={isKayakTraffic}
    />
  ) : null
}

export default UserSideMenuWithStore
